import { useMemo } from 'react'
import { qrMatrix } from '../labels/qr.ts'

/** A QR code drawn as one SVG path (crisp at any print size). `quiet` modules of white margin are part of the symbol. */
export function QrSvg({ text, quiet = 3, className, title }: { text: string; quiet?: number; className?: string; title?: string }) {
  const { d, size } = useMemo(() => {
    const m = qrMatrix(text)
    let d = ''
    for (let y = 0; y < m.size; y++) {
      let x = 0
      while (x < m.size) {
        if (!m.get(x, y)) { x++; continue }
        let run = 1
        while (x + run < m.size && m.get(x + run, y)) run++
        d += `M${x + quiet} ${y + quiet}h${run}v1h${-run}z`
        x += run
      }
    }
    return { d, size: m.size + quiet * 2 }
  }, [text, quiet])
  return (
    <svg viewBox={`0 0 ${size} ${size}`} className={className} role="img" aria-label={title ?? text} shapeRendering="crispEdges">
      <rect width={size} height={size} fill="#fff" />
      <path d={d} fill="#000" />
    </svg>
  )
}
